document.addEventListener('DOMContentLoaded', function() {
  function hideInShadow(shadowRoot) {
    if (!shadowRoot) return;
    const ratings = shadowRoot.querySelector('.loox-trust-badge-widget-ratings');
    const ratersCount = shadowRoot.querySelector('.loox-trust-badge-widget-ratings__raters-count');
    const paper = shadowRoot.querySelector('.loox-trust-badge-widget.lxs-paper');
    if (ratings) ratings.style.display = 'none';
    if (ratersCount) ratersCount.style.display = 'none';
    if (paper) paper.style.backgroundColor = 'white';
  }

  function scanForLoox() {
    const hosts = document.querySelectorAll('.loox-trust-badge-container');
    hosts.forEach(host => {
      if (host.shadowRoot) {
        hideInShadow(host.shadowRoot);
      } else {
        const ratings = host.querySelector('.loox-trust-badge-widget-ratings');
        const ratersCount = host.querySelector('.loox-trust-badge-widget-ratings__raters-count');
        const paper = host.querySelector('.loox-trust-badge-widget.lxs-paper');
        if (ratings) ratings.style.display = 'none';
        if (ratersCount) ratersCount.style.display = 'none';
        if (paper) paper.style.backgroundColor = 'white';
      }
    });
  }

  scanForLoox();
  setInterval(scanForLoox, 500);
}); 